import React from 'react';
import { toast } from 'sonner';
import CommonDialog from '../../../common/CommonDialog';
import { useCancelWorkOrder } from '../../../services/business/workOrders';

/**
 * Cancel a work order.
 *
 * Inventory (spec §9 R6): cancelling a work order never moves stock, from any status — only the
 * invoice a work order converts into ever consumes inventory.
 */
const CancelWorkOrderModal = ({ open, onClose, workOrder, onCancelled }) => {
    const cancelWorkOrder = useCancelWorkOrder();

    const handleConfirm = async () => {
        try {
            // PUT change-status/:id { status: 'cancelled' }
            await cancelWorkOrder.mutateAsync({ id: workOrder?._id });
            toast.success('Work order status updated successfully');
            onCancelled?.();
            onClose?.();
        } catch (error) {
            console.error('Error cancelling work order:', error);
        }
    };

    return (
        <CommonDialog
            open={open}
            onClose={onClose}
            onCancel={onClose}
            onSave={handleConfirm}
            loader={cancelWorkOrder.isPending}
            dialogTitle="Cancel Work Order?"
            dialogSubtitle="Cancelling this work order will prevent it from being converted into an invoice."
            cancelButtonText="KEEP WORK ORDER"
            cancelButtonWidth="180px"
            saveButtonText="CANCEL WORK ORDER"
            saveButtonWidth="195px"
        />
    );
};

export default CancelWorkOrderModal;
